export default function ({ store, route }) {
  
  if(process.client){
    // store.commit('language/ChangeLanguage', window.navigator.language);
  }
}